export default [
    {
      title: 'menu.Profile',
      icon: 'UserIcon',
      tagVariant: 'light-danger',
      route:'profile'
    },
  ]
  